<script>
import bem from '@/utils/bem';
import { mapActions } from 'vuex';
import toggleModal from '@/mixins/toggleModal';
import UploadImages from '@/components/ux/upload/Upload-images.vue';

const b = bem('art-collection');
export default {
  components: { UploadImages },
  data() {
    return {
      isDefault: false,
      files: [],
    };
  },
  props: {
    collection: Object,
    isNew: Boolean,
  },
  mixins: [toggleModal],
  methods: {
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
    ...mapActions({
      updateTemplateCollectionAction: 'createTemplate/updateTemplateCollection',
      createTemplateCollectionAction: 'createTemplate/createTemplateCollection',
    }),
    handleOk(values) {
      const collection = {
        name: values.name,
        description: values.description,
        disclaimer: values.disclaimer,
        isDefault: this.isDefault,
      };
      const file = this.files[0] ? this.files[0].file : null;
      if (!this.isNew) {
        collection.id = this.collection.id;
        this.updateTemplateCollectionAction({
          collection,
          file,
        });
      } else {
        this.createTemplateCollectionAction({
          collection,
          file,
        });
      }
      this.hideModal();
    },
  },
  mounted() {
    if (!this.isNew) {
      this.isDefault = this.collection.isDefault;
      this.files = this.collection.imageUri ? [{
        file: null,
        url: this.collection.imageUri,
      }] : [];
    }
  },
};
</script>

<template>
  <a-modal :open="show" :footer="null" width="500px" @cancel="hideModal">
    <div :class="b('')">
      <FormKit
        type="form"
        :submit-label="isNew ? 'Create' : 'Save'"
        @submit="handleOk"
      >
        <h1>{{ isNew ? 'New collection' : `Edit ${collection.name}` }}</h1>
        <div :class="b('content')">
          <div :class="b('left-side')">
            <div :class="b('input')">
              <FormKit
                  type="text"
                  name="name"
                  label="Title"
                  validation="required"
                  placeholder="Type collection title"
                  :value="collection.name"
              />
            </div>
            <div :class="b('input')">
              <FormKit
                  type="textarea"
                  name="description"
                  label="Description"
                  validation="required"
                  placeholder="Type collection description"
                  :value="collection.description"
              />
            </div>
            <div :class="b('input')" v-if="!isNew">
              <FormKit
                  type="text"
                  name="disclaimer"
                  label="Disclaimer"
                  placeholder="Type collection disclaimer"
                  :value="collection.disclaimer"
              />
            </div>
            <div :class="b('input', { row: true })">
              <span :class="b('input-title')">Default collection</span>
              <a-switch
                  checked-children="Yes"
                  un-checked-children="No"
                  v-model:checked="isDefault"
              />
            </div>
          </div>
          <div :class="b('right-side')">
            <UploadImages
                :is-multiple="false"
                v-model:files="files"
                :initial-images="!isNew && collection.imageUri ? [collection.imageUri] : []"
            />
          </div>
        </div>
      </FormKit>
    </div>
  </a-modal>
</template>

<style lang="scss">
@import "@/styles/variables";

.art-collection {
  &__content {
    display: flex;
    justify-content: space-between;
  }

  &__input {
    width: 200px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;

    &_row {
      flex-direction: row;
      margin-bottom: 20px;
    }
  }

  &__input-title {
    margin-right: 10px;
  }

  &__button {
    width: 200px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
  }

  &__right-side {
    margin-top: 18px;

    .ant-upload-list-picture-card,
    .ant-upload-list-picture-select-card,
    .ant-upload-select,
    .ant-upload,
    .ant-upload-list-item-container {
      width: 200px !important;
      height: 200px !important;
    }
  }
}
.formkit-outer {
  width: 100%;
}
</style>
